import {twJoin} from "tailwind-merge";

// TODO: Convert this to GenericErrorComponent, and take border/rounded as props?
export function TableErrorComponent({error, className}: {error: string; className?: string}) {
    return (
        <div
            className={twJoin(
                "w-full h-full rounded-[0.5rem]",
                "bg-[#ffe9e9] text-[#ff0000]",
                "border-ds-border-width border-solid border-ds-border",
                "grid grid-cols-1 grid-rows-1 place-items-center",
                className,
            )}
        >
            Error: {error}
        </div>
    );
}
